import React from 'react'
import { Save2 } from 'iconsax-react'
import { useAppSelector } from '@SonarCX/hooks/redux'

import CommonButton from '../CommonButton'
import Dropdown from '@SonarCX/components/atoms/Dropdown'

import { selectTaskType } from '@SonarCX/slices/taskType'
import useTaskMultiEdit from '../hooks/useTaskMultiEdit'
import useStyles from '../commonStyles'

const SetType: React.FC = () => {
  const { typesValues: types } = useAppSelector(selectTaskType)

  const { selected, patchTasks } = useTaskMultiEdit()

  const [value, setValue] = React.useState(null)

  const classes = useStyles()

  const handleClose = React.useCallback(() => {
    setValue(null)
  }, [])

  const handleAccept = React.useCallback(async () => {
    const updates: TaskPatch[] = selected.map(id => ({
      id,
      type_id: value
    }))
    await patchTasks({ updates, message: 'Type updated' })
    handleClose()
  }, [selected, value, patchTasks, handleClose])

  return (
    <CommonButton
      title='Set type'
      Icon={Save2}
      onAccept={handleAccept}
      onClose={handleClose}
    >
      <div className={classes.content}>
        <div className={classes.title}>Type</div>

        <Dropdown
          options={types.map(({ id }) => id)}
          renderOption={id => types.find(type => type.id === id)?.name || ''}
          selected={value}
          onSelect={id => setValue(id)}
          hideAdd
          stringOnly
        >
          <div data-testid='task-type'>
            {types.find(({ id }) => id === value)?.name || 'Unassigned'}
          </div>
        </Dropdown>
      </div>
    </CommonButton>
  )
}

export default SetType
